// 资料库（泛安全领域知识空间）静态展示数据。
// 本期没有后端接口（server / opencode / protocol 三个包均无 knowledge 相关实现），
// 因此所有内容硬编码在此。后续接真实数据时，只需把 KB_DOMAINS 换成接口返回值。

/** 外部资料库入口（点击主按钮与任意卡片都会跳到这里） */
export const KNOWLEDGE_LIBRARY_URL = "http://172.21.10.182:7211/dashboard"

export type KnowledgeCategoryCode =
  | "ai-security"
  | "content-safety"
  | "agent-security"
  | "data-privacy"
  | "red-blue"
  | "forensics"
  | "threat-intel"
  | "governance"

export type KnowledgeGlyphName =
  | "neural"
  | "shield"
  | "bot"
  | "lock"
  | "duel"
  | "fingerprint"
  | "radar"
  | "scale"

export type KnowledgeCategory = {
  code: KnowledgeCategoryCode
  label: string
  glyph: KnowledgeGlyphName
}

export type KnowledgeDomain = {
  id: string
  category: KnowledgeCategoryCode
  title: string
  description: string
  tags: string[]
}

// 顺序即 Chip 的展示顺序。封面渐变色在 knowledge-base.css 里按
// `[data-kb-category="<code>"]` 匹配，新增分类时两处都要加。
export const KB_CATEGORIES: KnowledgeCategory[] = [
  { code: "ai-security", label: "人工智能安全", glyph: "neural" },
  { code: "content-safety", label: "大模型内容安全", glyph: "shield" },
  { code: "agent-security", label: "智能体应用安全", glyph: "bot" },
  { code: "data-privacy", label: "数据与隐私", glyph: "lock" },
  { code: "red-blue", label: "攻防对抗", glyph: "duel" },
  { code: "forensics", label: "鉴伪与取证", glyph: "fingerprint" },
  { code: "threat-intel", label: "威胁情报", glyph: "radar" },
  { code: "governance", label: "治理与合规", glyph: "scale" },
]

export const KB_CATEGORY_BY_CODE = Object.fromEntries(
  KB_CATEGORIES.map((item) => [item.code, item]),
) as Record<KnowledgeCategoryCode, KnowledgeCategory>

export const KB_DOMAINS: KnowledgeDomain[] = [
  {
    id: "llm-security-baseline",
    category: "ai-security",
    title: "大模型安全评估基线",
    description: "越狱、提示注入、数据投毒的分级评估用例与判定口径，作为模型上线前的统一验收尺子。",
    tags: ["评估基线", "提示注入"],
  },
  {
    id: "ai-red-team",
    category: "ai-security",
    title: "AI 红队手法库",
    description: "提示注入、模型窃取、训练数据投毒等真实攻击手法的沉淀、复现要点与防守反制。",
    tags: ["红队", "对抗样本"],
  },
  {
    id: "harmful-content-spec",
    category: "content-safety",
    title: "有害内容识别规范",
    description: "涉政、暴恐、低俗等风险类目的分级识别口径、边界样本与争议判定原则。",
    tags: ["内容分级", "样本集"],
  },
  {
    id: "refusal-playbook",
    category: "content-safety",
    title: "审核话术与拒答模板",
    description: "分级响应策略、拒答话术与用户申诉流程的标准化模板，兼顾合规与体验。",
    tags: ["拒答", "风控策略"],
  },
  {
    id: "agent-tool-boundary",
    category: "agent-security",
    title: "Agent 工具调用边界",
    description: "工具白名单、最小权限模型与越权调用的检测点，防止智能体越界行事。",
    tags: ["权限模型", "工具白名单"],
  },
  {
    id: "skill-supply-chain",
    category: "agent-security",
    title: "MCP / Skill 供应链安全",
    description: "第三方技能准入、代码审计与签名校验的落地检查清单，守住插件入口。",
    tags: ["供应链", "准入"],
  },
  {
    id: "training-data-compliance",
    category: "data-privacy",
    title: "训练数据合规与脱敏",
    description: "数据来源合法性审查、PII 识别与脱敏规则的组合拳，覆盖采集到入模全链路。",
    tags: ["数据合规", "PII"],
  },
  {
    id: "privacy-impact-assessment",
    category: "data-privacy",
    title: "隐私影响评估实务",
    description: "个人信息影响评估（PIA）模板与典型落地案例复盘，把合规要求变成可执行动作。",
    tags: ["PIA", "合规"],
  },
  {
    id: "red-blue-review",
    category: "red-blue",
    title: "实战攻防演练复盘",
    description: "红蓝对抗复盘要点、典型攻击链路拆解与可复用的防守剧本，从一次演练沉淀一套能力。",
    tags: ["红蓝对抗", "复盘"],
  },
  {
    id: "deepfake-forensics",
    category: "forensics",
    title: "深度伪造检测与取证",
    description: "音视频与图像鉴伪的量化指标、取证流程与报告规范，让结论经得起追问。",
    tags: ["深度伪造", "取证"],
  },
  {
    id: "threat-intel-judgement",
    category: "threat-intel",
    title: "安全情报研判方法",
    description: "情报源分级、IOC 研判流程与可信度评分模型，把碎片线索收敛成可行动结论。",
    tags: ["IOC", "情报分级"],
  },
  {
    id: "ai-compliance-map",
    category: "governance",
    title: "大模型安全合规图谱",
    description: "国内外监管要求与标准映射，落到一份能直接对照打勾的检查表。",
    tags: ["合规", "标准"],
  },
]
